/* eslint-disable no-unused-vars */
import {
    BoxedRow,
    ButtonLayout,
    ButtonPrimary,
    FixedFooterLayout,
    IconChevronLeftRegular,
    NavigationBar,
    RadioButton,
    RadioGroup,
    Stack,
    Text1,
    Text2,
    Text3,
    Text6,
    TextLink,
    ThemeVariant,
    skinVars,
    useDialog,
    useWindowSize,
} from '@telefonica/mistica';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getBonusOffering, hireBonus } from '../../../services/ProductService';
import navigateParams from '../../../utils/navigation/navigateParams';
import './index.scss';
import { formatPrices } from '../../../utils/dataTransformation/unitsConversion';
import { useTranslation } from 'react-i18next';
import { ErrorStateUIData } from '../../../models/interfaces';
import { setInfoError } from '../../../utils/dataTransformation/errorMesssages';
import { TrackingEvents } from '../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../utils/navigation/controlDevices';
import Stopper from '../../../components/Stopper';
import { managementEnvironment } from '../../../utils/dataTransformation/environments';
import BreadCrumbsWrapper from '../../../components/BreadcrumbsWrapper';
import { getRoleLine } from '../../../utils/dataTransformation/productConsumption';
import { useConfigureLineContext } from '../../../context/configure-line-context/ConfigureLineContext';

const BonusAvailable: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const productId: any = searchParams.get('productId');
    const homeDisabled = managementEnvironment().VITE_STOPPER_HOME_DISABLED;
    const { isConvergent } = useConfigureLineContext();
    const size = useWindowSize();
    const [error, setError] = useState<ErrorStateUIData>({ title: '', localizedDescription: '', id: '' });
    const [hasError, setHasError] = useState(false);
    const { trackingScreenView } = new TrackingEvents();
    const { dialog } = useDialog();
    const consumptions = localStorage.getItem('storages')!;
    const storage = localStorage.getItem('storage');
    let storageJson;

    if (storage) {
        storageJson = JSON.parse(storage);
    }

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }

        getBonusOffering(productId)
            .then((results: any) => {
                setData(results.data);
            })
            .catch((err) => {
                setError(setInfoError(err));
                setHasError(true);
            });

        () => {
            clearTimeout(timeoutRef.current);
        };
    }, []);

    const [data, setData] = useState<any>();
    const [valueBonus, setValueBonus] = useState<any>(-1);

    const [priceTotal, setPriceTotal] = useState<any>(0);
    const [offeringId, setOfferingId] = useState<any>();

    let bonusOffering: any;
    if (data) {
        bonusOffering = data;
    }
    let timeoutRef = useRef<number>(0);

    useEffect(() => {
        if ((valueBonus === 1 || valueBonus === 0) && bonusOffering) {
            setPriceTotal(bonusOffering[valueBonus].price);
            setOfferingId(bonusOffering[valueBonus].offeringId);
        }
        () => {
            clearTimeout(timeoutRef.current);
        };
    }, [valueBonus]);

    const sendToNative = (url: string, description: any, type: any, title: any, err?: any) => {
        const titleFeedback = description === 'SUCCESS' ? 'Estamos activando tu bono' : 'Bono extra no activado';
        const subtitleFeedback =
            description === 'SUCCESS'
                ? 'Tu bono extra está procesándose.\n\nEn unos minutos te enviaremos un SMS de confirmación y lo verás activo en Mi O2.'
                : 'Lo sentimos, no hemos podido activar tu bono.\n\nPor favor, inténtalo más tarde.\n\nSi el problema persiste, ponte en contacto con nosotros en el 1551.';
        const state = description;
        const queryParams = {
            productId: productId,
            title: titleFeedback,
            type: description,
            subtitle: subtitleFeedback,
            state: state,
            errorCode: err ? err : '',
        };
        if (url === '/bonus-available/bonus-available-modal-extra-bonus') {
            dialog({
                title: `${t('modalExtraBonusTitle')}`,
                message: (() => {
                    return (
                        <Stack space={16}>
                            <Text3 light color={skinVars.colors.textSecondary}>
                                {description}
                            </Text3>
                        </Stack>
                    );
                })() as any,
                link: (
                    <TextLink
                        underline='on hover'
                        onPress={() => {
                            window.open('https://o2online.es/ayuda/bonoextradatos/', '_blank');
                        }}
                    >
                        <Text2 color={skinVars.colors.textLink} medium>
                            {t('modalExtraBonusLink')}
                        </Text2>
                    </TextLink>
                ),
                onAccept() {},
                acceptText: t('calldivertalerttextbtn'),
            });
        } else {
            const storage = { description };
            if (navigateParams(type, url, queryParams, storage, title)) {
                navigate(`${url + '?type=' + description}`);
            }
        }
    };

    const dataBonus = {
        productId: productId,
        offeringId: offeringId,
    };

    const activateBonus = () => {
        hireBonus(dataBonus)
            .then((results: any) => {
                sendToNative('/mobile/bonus-available/feedback', 'SUCCESS', 'feedback-success', '');
            })
            .catch((err) => {
                console.error(err);
                sendToNative('/mobile/bonus-available/feedback', 'ERROR', 'feedback-error', '', err?.data?.id);
            });
    };

    return homeDisabled ? (
        <Stopper></Stopper>
    ) : (
        <>
            {!hasError && (
                <div className='bonusAvailable-page'>
                    <div
                        className='bonusAvailable-page__header'
                        style={{
                            background: skinVars.colors.background,
                            borderBottom: size.width >= 1024 ? `1px solid ${skinVars.colors.divider}` : '',
                        }}
                    >
                        {!(isWebviewAndroid || isWebviewIOS) && (
                            <>
                                <div className='bonusAvailable-page__header-navigationBar'>
                                    <NavigationBar
                                        title={t('returnBonusAvailable')}
                                        onBack={() => {
                                            navigate(-1);
                                        }}
                                    />
                                </div>
                                <div
                                    className='bonusAvailable-page__header-return'
                                    onClick={() => {
                                        navigate(-1);
                                    }}
                                >
                                    <div className='bonusAvailable-page__header-return-icon'>
                                        <IconChevronLeftRegular color={skinVars.colors.neutralHigh} size={20} />
                                    </div>
                                    <Text2 medium color={skinVars.colors.neutralHigh}>
                                        {t('returnResponsive')}
                                    </Text2>
                                </div>
                            </>
                        )}
                        <div className='bonusAvailable-page__header-breadcrumbs'>
                            <ThemeVariant>
                                <BreadCrumbsWrapper
                                    title={t('returnBonusAvailable')}
                                    breadcrumbs={
                                        !isConvergent
                                            ? [{ title: t('breadcrumbsHome'), url: '/home' }]
                                            : [
                                                  { title: t('breadcrumbsHome'), url: '/home' },
                                                  {
                                                      title: getRoleLine(
                                                          JSON.parse(consumptions),
                                                          storageJson.productPsId,
                                                      ),
                                                      url: `/mobile?productPsId=${storageJson?.productPsId}`,
                                                  },
                                              ]
                                    }
                                />
                            </ThemeVariant>
                        </div>
                    </div>

                    <FixedFooterLayout
                        footer={
                            <div className='bonusAvailable-page__footer'>
                                <ButtonLayout
                                    align={'left'}
                                    primaryButton={
                                        <>
                                            <div className='bonusAvailable-page__footer-text'>
                                                <Text1 regular>{t('totalTaxBuyBonds')}</Text1>
                                                <div className='bonusAvailable-page__footer-text-price'>
                                                    <Text3 medium>{formatPrices(priceTotal, 'spent')}</Text3>
                                                </div>
                                            </div>
                                            <ButtonPrimary onPress={activateBonus} disabled={valueBonus === -1}>
                                                {t('buttonBuyBonds')}
                                            </ButtonPrimary>
                                        </>
                                    }
                                />
                            </div>
                        }
                    >
                        <div className='bonusAvailable-page__body'>
                            <div className='bonusAvailable-page__body-title'>
                                <Text3 regular>{t('bondsAvailableTitle')}</Text3>
                            </div>
                            <RadioGroup name={'bonus'} value={valueBonus} onChange={setValueBonus}>
                                {bonusOffering &&
                                    bonusOffering.map((bonus: any, index: any) => {
                                        return (
                                            <div key={index}>
                                                <div className='bonusAvailable-page__body__content' key={index}>
                                                    <BoxedRow
                                                        title={''}
                                                        extra={
                                                            <div>
                                                                <Text3 regular>{bonus.name}</Text3>
                                                                <div className='bonusAvailable-page__body__content-euros'>
                                                                    <Text6>{formatPrices(bonus.price, 'rate')}</Text6>
                                                                </div>
                                                                <TextLink
                                                                    underline='on hover'
                                                                    className='bonusAvailable-page__body__content-link'
                                                                    onPress={() => {
                                                                        sendToNative(
                                                                            '/bonus-available/bonus-available-modal-extra-bonus',
                                                                            bonus.description,
                                                                            'modeModal-backgroundWhite',
                                                                            bonus.name,
                                                                        );
                                                                    }}
                                                                >
                                                                    {t('moreInformation')}
                                                                </TextLink>
                                                            </div>
                                                        }
                                                        right={<RadioButton value={index}></RadioButton>}
                                                    />
                                                </div>
                                            </div>
                                        );
                                    })}
                            </RadioGroup>
                        </div>
                    </FixedFooterLayout>
                </div>
            )}
        </>
    );
};

export default BonusAvailable;
